// =====================================================================
// paginas/comunicacao.js — Templates e histórico de WhatsApp.
//
// A imobiliária escreve o próprio texto. Nenhuma mensagem é hardcoded:
// mudar o tom da cobrança não pode exigir deploy.
//
// Todo envio passa pelo ponto único (_lib/whatsapp.js) com dedup forte.
// =====================================================================

import { sb } from '../../../../packages/ui/cliente.js';
import { icon, escapeHtml, tabela, badge, modal, checar } from '../ui.js';
import { data } from '../../../../packages/ui/format.js';

let sub = 'templates';

export async function pagComunicacao(el, estado) {
  el.innerHTML = `
    <div class="cabecalho"><h2>Comunicação</h2></div>
    <div style="display:flex;gap:8px;margin-bottom:20px" id="sa">
      <button data-s="templates">${icon('editar')} Mensagens</button>
      <button data-s="historico">${icon('mensagens')} Histórico</button>
    </div>
    <div id="sub"></div>`;

  el.querySelectorAll('#sa button').forEach(b => {
    b.classList.toggle('primaria', b.dataset.s === sub);
    b.onclick = () => { sub = b.dataset.s; pagComunicacao(el, estado); };
  });

  const alvo = el.querySelector('#sub');
  if (sub === 'templates') await templates(alvo, estado);
  else await historico(alvo);
}

async function templates(el, estado) {
  const lista = checar(await sb.from('whatsapp_templates').select('*').order('codigo'));

  el.innerHTML = `
    <div class="aviso info">${icon('alerta')}
      <div>As variáveis entre chaves são trocadas na hora do envio: <code>{nome}</code>,
      <code>{valor}</code>, <code>{vencimento}</code>, <code>{pix}</code>.
      Usar uma variável que não está na lista de válidas faz o envio falhar — de propósito:
      melhor não enviar do que enviar <code>{nome}</code> literal para o inquilino.</div></div>
    ` + tabela([
    { th: 'Código', td: t => `<strong>${escapeHtml(t.codigo)}</strong>` },
    { th: 'Descrição', td: t => escapeHtml(t.descricao || '') },
    { th: 'Mensagem', td: t => `<span style="color:var(--tinta-media)">${escapeHtml(t.corpo.slice(0, 90))}…</span>` },
    { th: 'Ativo', td: t => badge(t.ativo ? 'ativo' : 'inativo', t.ativo ? 'verde' : 'cinza') },
    { th: '', cls: 'acoes', td: t => `<button class="icone" data-ed="${t.id}">${icon('editar')}</button>` }
  ], lista, 'Nenhum template.');

  el.querySelectorAll('[data-ed]').forEach(b => b.onclick = () => {
    const t = lista.find(x => x.id === b.dataset.ed);
    modal({
      titulo: `Mensagem — ${t.codigo}`,
      dados: t,
      aviso: `Variáveis válidas: ${(t.variaveis_validas || []).map(v => '{' + v + '}').join(', ') || 'nenhuma'}`,
      campos: [
        { nome: 'descricao', label: 'Descrição', full: true },
        { nome: 'corpo', label: 'Mensagem', tipo: 'textarea', full: true, req: true },
        { nome: 'ativo', label: 'Ativo', tipo: 'checkbox' }
      ],
      onSalvar: async (d) => {
        checar(await sb.from('whatsapp_templates').update({
          descricao: d.descricao, corpo: d.corpo, ativo: d.ativo,
          atualizado_em: new Date().toISOString(), atualizado_por: estado.perfil.id
        }).eq('id', t.id));
        pagComunicacao(el.closest('main'), estado);
      }
    });
  });
}

async function historico(el) {
  const lista = checar(await sb.from('whatsapp_mensagens')
    .select('*').order('criado_em', { ascending: false }).limit(200));

  const CORES = { sent: 'azul', delivered: 'azul', read: 'verde', failed: 'vermelho', received: 'cinza' };

  el.innerHTML = tabela([
    { th: 'Quando', td: m => data(m.criado_em) },
    { th: 'Contexto', td: m => escapeHtml(m.contexto) },
    { th: 'Telefone', td: m => escapeHtml(m.telefone) },
    { th: 'Mensagem', td: m => escapeHtml(m.mensagem.slice(0, 70)) + '…' },
    { th: 'Status', td: m => badge(m.status, CORES[m.status] || 'cinza') }
  ], lista, 'Nenhuma mensagem enviada ainda.');
}
